// This class exists only because the
//   /v3.1/reporting/insights/bulklookup/byDimensions
// api is incredibly flakey.  This is class tries to work around these issues.
//
//  - Page size is ignored for certain dimensions like COUNTRY and whole set is returned
//  - The first page can return more results than requested and that is subtracted from later pages
//
// If the api were fixed, this class would no longer be necessary

import { uniqBy } from 'lodash';
import { BulkLookupResponse } from 'services/MetaInfoService/MetaInfoService';
import { BulkLookupValue } from 'services/SprinklrAPIService/SprinklrAPIService';
import { ChannelType } from '@sprinklr/stories/post/PostsRequest';

export interface AsyncListItem {
    id: string;
    label: string;
    type?: string;
    snType?: string;
    channelType?: string;
    profileImgUrl?: string;
    channel?: ChannelType;
    entityType?: string;
    message?: string;
    additional?: any;
}

export interface AsyncListData {
    options: Array<AsyncListItem>;
    complete: boolean;
}

export default class DimensionValues {
    private valuesOverflow: Array<BulkLookupValue> = [];

    constructor(
        private page: number,
        private pageCount: number,
        private hasMore: boolean,
        private values: Array<BulkLookupValue>,
        private previous?: DimensionValues,
        private specialCase: boolean = false
    ) {
        // Api can return the same results (ie. COUNTRY),
        // no matter what the page # requested is
        if (previous?.hasMore === false) {
            if (previous.valuesOverflow.length) {
                this.values = previous.valuesOverflow.slice(0, pageCount);
                this.valuesOverflow = previous.valuesOverflow.slice(pageCount);
            } else {
                this.values = [];
            }
            // If api returns more than we want, then stash the extra away
        } else if (values.length > pageCount) {
            this.values = values.slice(0, pageCount);
            this.valuesOverflow = values.slice(pageCount);
        }

        // TODO:  Not sure how this every originally worked
        // if (specialCase) {
        //     this.checkHierarchy();
        // }
    }

    getValues(): Array<BulkLookupValue> {
        return this.values;
    }

    noResults(): boolean {
        return (
            this.page === 0 && !this.values.length && !this.valuesOverflow.length && !this.hasMore
        );
    }

    toAsyncList(): AsyncListData {
        const result = {
            options: uniqBy(
                this.values?.map((value: any) => ({
                    id: value.postId || value.id,
                    label: value.content?.message || value.contactInfo?.fullName || value.name,
                    type: value.type,
                    snType: value.snType ?? value.socialProfiles?.[0].type ?? value.id,
                    channel: value.channel,
                    channelType: value.channelType,
                    profileImgUrl: value.profileImgUrl ?? value.socialProfiles?.[0].profileImageUrl,
                    entityType: value.entityType,
                    message: value.content?.message,
                    additional: value.additional,
                })),
                'id'
            ),
            complete: !this.hasMore && !this.valuesOverflow.length,
        };

        // Must include options as array or AsyncSelect errors out.
        if (!result.options) {
            result.options = [];
        }

        return result;
    }

    // TODO:  Not sure how this every originally worked
    // Used when dimension is HIERARCHY_ID
    // private checkHierarchy() {
    //     if (
    //         this.values.find((value: any) => value.assetType === 'COMMERCE_PRODUCT') &&
    //         this.values.find((value: any) => value.assetType === 'INTEL_LOCATION')
    //     ) {
    //         this.hasMore = false;
    //         this.values = [
    //             {
    //                 id: "COMMERCE_PRODUCT",
    //                 displayName: 'Product',
    //                 options: this.values.filter(
    //                     (value: any) => value.assetType === 'COMMERCE_PRODUCT'
    //                 ),
    //             },
    //             {
    //                 id: "INTEL_LOCATION",
    //                 displayName: 'Location',
    //                 options: this.values.filter(
    //                     (value: any) => value.assetType === 'INTEL_LOCATION'
    //                 ),
    //             },
    //         ];
    //     }
    // }
}
